import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Kuponger", -1)
const _hoisted_3 = [
  _hoisted_2
]

import {computed, onMounted, reactive, watch} from 'vue';
import {CouponStore} from "@/stores/coupon";
import router from '@/router';
import {CouponState} from "@/types";

interface State {
    visible: boolean,
    count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CouponsIcon',
  setup(__props) {

const couponStore = CouponStore();
const state = reactive<State>({
    visible: false,
    count: 0
});

/* Watch */
watch(() => couponStore.coupons, () => {
    setState();
}, { deep: true });

/* Computed */
const visible = computed(() => {
    return state.visible;
});

/* Functions */
const onClick = () => {
    if (state.count !== 0) {
        router.push({
            name: 'coupons'
        });
    }
}
const setState = () => {
    state.count = 0;
    couponStore.coupons.forEach((c)=>{
       if(c.state == CouponState.Active || c.state == CouponState.Unused){
            state.count++;
        }
    });
    
    //state.visible = (state.count > 0);
    state.visible = (state.count > 0) && document.documentElement.classList.contains('plt-pwa');
}

/* Lifecycle Hooks */
onMounted(() => setState())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(visible))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "coupons-btn",
            "data-value": state.count,
            onClick: onClick
          }, _hoisted_3, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})